export const CLEAR_UPLOAD_BILLS = 'CLEAR_UPLOAD_BILLS';

export const SUBMIT_UPLOAD_BILL_FAILURE = 'SUBMIT_UPLOAD_BILL_FAILURE';
export const SUBMIT_UPLOAD_BILL_REQUEST = 'SUBMIT_UPLOAD_BILL_REQUEST';
export const SUBMIT_UPLOAD_BILL_SUCCESS = 'SUBMIT_UPLOAD_BILL_SUCCESS';
